<template>
  <div class="under-construction-container">
    <img src="@/assets/logo.png" alt="Логотип" class="logo" />
    <h1 class="title">Under Construction</h1>
    <p class="message">We are working on adding new pages.</p>
  </div>
</template>

<style scoped>
.under-construction-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 480px);
}

.logo {
  width: 300px;
  margin-bottom: 20px;
}

.title {
  font-size: 2.5em;
  color: rgb(var(--m-color));
  margin-bottom: 10px;
  text-align: center;
}

.message {
  font-size: 1.2em;
  color: rgb(var(--s-color));
  text-align: center;
}
</style>

<script>
export default {
  name: "UnderConstructionView",
};
</script>
